import React from "react";
import { useState } from "react";
import HomeContent1 from "./HomeContent1";
import HomeContent2 from "./HomeContent2";

export default function Home() {
  const [current, setCurrent] = useState("HomeContent2");

  const toggleContent = () => {
    // 执行动画
    setTimeout(() => {
      setCurrent((current) =>
        current === "HomeContent1" ? "HomeContent2" : "HomeContent1"
      );
    }, 3000);
  };

  return (
    <div>
      {current === "HomeContent1" && <HomeContent1 toggle={toggleContent} />}
      {current === "HomeContent2" && <HomeContent2 toggle={toggleContent} />}
    </div>
  );
}
